import Login from '@/views/login.vue';
import Logout from '@/views/logout.vue';
import User from '@/views/user.vue';
// Config
import Config from '@/views/config/config.vue';
import ConfigRoutes from '@/routes/config';
// DMP
import Actions from '@/views/dmp/actions.vue';
import Archives from '@/views/dmp/archives.vue';
import CustomPage from '@/views/dmp/custom-page.vue';
import Dashboard from '@/views/dmp/dashboard.vue';
import Indicators from '@/views/dmp/indicators.vue';
import MeetingInfos from '@/views/dmp/meeting-infos.vue';
import MeetingRating from '@/views/dmp/meeting-rating.vue';
import MeetingRoles from '@/views/dmp/meeting-roles.vue';
import MeetingSafety from '@/views/dmp/meeting-safety.vue';
import Pending from '@/views/dmp/pending.vue';
import Problems from '@/views/dmp/problems.vue';
import Schedule from '@/views/dmp/schedule.vue';
import Stats from '@/views/dmp/stats.vue';
// DMP Management
import MgtActions from '@/views/dmp/management/actions.vue';
import MgtIndicators from '@/views/dmp/management/indicators.vue';
import MgtProblems from '@/views/dmp/management/problems.vue';
import MgtStats from '@/views/dmp/management/stats.vue';
// GW
import GwChecklists from '@/views/gw/checklists.vue';
import GwCompleted from '@/views/gw/completed.vue';
import GembaWalks from '@/views/gw/gemba-walks.vue';
import GwRating from '@/views/gw/rating.vue';
import GwStart from '@/views/gw/start.vue';
import GwStats from '@/views/gw/stats.vue';
import GwTemplates from '@/views/gw/templates.vue';
import GwIndicators from '@/views/gw/gw-indicators.vue';
// Overlay
import ConfigurablePage from '@/views/overlay/configurable-page.vue';
import DetailedIndicator from '@/views/overlay/detailed-indicator.vue';
// Settings
import SettingsActions from '@/views/settings/actions.vue';
import SettingsConfigPages from '@/views/settings/configurable-pages.vue';
import SettingsDashboard from '@/views/settings/dashboard.vue';
import SettingsIndicators from '@/views/settings/indicators.vue';
import SettingsMain from '@/views/settings/main.vue';
import SettingsMeetings from '@/views/settings/meetings.vue';
import SettingsProblems from '@/views/settings/problems.vue';
import Settings from '@/views/settings/settings.vue';
import SettingsTeam from '@/views/settings/team.vue';
import SettingsGw from '@/views/settings/gemba-walks.vue';
// Vitality hub
import VitalityHub from '@/views/vitality/vitality-hub.vue';
// Customer success
import JiraIssues from '@/views/customer-reports/jira-issues.vue';
import JiraIssueDetails from '@/views/customer-reports/jira-issue-details.vue';
// Access restricted to Shizen staff
import ShizenStatsOverview from '@/views/shizen-stats/overview.vue';


export default [
  // -----
  // Config
  // --
  {
    path: '/config',
    component: Config,
    meta: { loginPage: true, noLogPage: true, noCheckLogin: true },
    children: ConfigRoutes,
  },
  // -----
  // Pages
  // -----
  {
    path: '/login',
    component: Login,
    meta: { loginPage: true, noLogPage: true },
  },
  {
    path: '/logout',
    component: Logout,
  },
  {
    path: '/user',
    component: User,
  },
  {
    path: '/settings',
    component: Settings,
    children: [
      {
        path: 'indicators',
        component: SettingsIndicators,
        props: true,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'main',
        component: SettingsMain,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'actions',
        component: SettingsActions,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'problems',
        component: SettingsProblems,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'dashboard',
        component: SettingsDashboard,
        name: 'dashboardSettings',
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'meetings',
        component: SettingsMeetings,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'team',
        component: SettingsTeam,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'configurable-pages',
        component: SettingsConfigPages,
        meta: {
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
      {
        path: 'gemba-walks',
        component: SettingsGw,
        meta: {
          requireGW: true,
          requireNonCovid: true,
          fallbackRoute: '/settings',
        },
      },
    ],
  },
  // ---------
  // DMP pages
  // ---------
  {
    path: '/dashboard',
    component: Dashboard,
  },
  {
    path: '/indicators',
    component: Indicators,
  },
  {
    path: '/actions',
    component: Actions,
    name: 'dmpActions',
  },
  {
    path: '/pending',
    component: Pending,
    name: 'dmpPending',
  },
  {
    path: '/problems',
    component: Problems,
    name: 'dmpProblems',
  },
  {
    path: '/schedule',
    component: Schedule,
  },
  {
    path: '/stats',
    component: Stats,
  },
  {
    path: '/archives',
    component: Archives,
  },
  // -------------------
  // Daily meeting pages
  // -------------------
  {
    path: '/meeting-infos',
    component: MeetingInfos,
  },
  {
    path: '/meeting-safety/:id',
    component: MeetingSafety,
    props: true,
  },
  {
    path: '/custom-page/:id',
    component: CustomPage,
    props: true,
  },
  {
    path: '/meeting-rating',
    component: MeetingRating,
    meta: {
      requireMeeting: true,
    },
  },
  {
    path: '/meeting-roles',
    component: MeetingRoles,
    meta: {
      requireMeeting: true,
    },
  },
  // ------------
  // Vitality hub
  // ------------
  {
    path: '/vitality-hub',
    component: VitalityHub,
    meta: {
      requireNonCovid: true,
    },
  },
  // --------------------
  // DMP management pages
  // --------------------
  {
    path: '/it-problems',
    component: MgtProblems,
    meta: {
      requireNonCovid: true,
    },
  },
  {
    path: '/it-actions',
    component: MgtActions,
    meta: {
      requireNonCovid: true,
    },
  },
  {
    path: '/it-indicators',
    component: MgtIndicators,
    meta: {
      requireNonCovid: true,
    },
  },
  {
    path: '/it-stats',
    component: MgtStats,
    meta: {
      requireNonCovid: true,
    },
  },
  // ----------------
  // Gemba Walk pages
  // ----------------
  {
    path: '/gemba-walks',
    component: GembaWalks,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-templates',
    component: GwTemplates,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-stats',
    component: GwStats,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-checklists',
    component: GwChecklists,
    meta: {
      requireGW: true,
      requireNonCovid: true,
      fallbackRoute: '/gw-templates',
    },
  },
  {
    path: '/gw-start',
    component: GwStart,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-start/:templateId',
    component: GwStart,
    props: true,
    meta: {
      requireGW: true,
      requireNonCovid: true,
      fallbackRoute: '/gw-templates',
    },
  },
  {
    path: '/gw-completed',
    component: GwCompleted,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-completed/:gembaWalkId',
    component: GwCompleted,
    props: true,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-rating',
    component: GwRating,
    meta: {
      requireGW: true,
    },
  },
  {
    path: '/gw-indicators',
    component: GwIndicators,
    meta: {
      requireGW: true,
    },
  },
  // -------------
  // Overlay pages
  // -------------
  {
    path: '/indicator',
    component: DetailedIndicator,
  },
  {
    path: '/configurable-page',
    component: ConfigurablePage,
    meta: {
      requireNonCovid: true,
    },
  },
  // ----------------
  // Customer success
  // ----------------
  {
    path: '/shizen-issues',
    component: JiraIssues,
    name: 'jiraIssues',
  },
  {
    path: '/shizen-issues/:id',
    component: JiraIssueDetails,
    name: 'jiraIssueDetails',
  },
  // -----------------------
  // Shizen restricted pages
  // -----------------------
  {
    path: '/shizen-stats',
    redirect: '/shizen-stats/overview',
  },
  {
    path: '/shizen-stats/overview',
    component: ShizenStatsOverview,
    name: 'shizenStatsOverview',
    children: [
      {
        path: ':companyId',
        component: ShizenStatsOverview,
        name: 'shizenStatsCompany',
        meta: {
          fallbackRoute: 'shizenStatsOverview',
        },
        children: [
          {
            path: ':teamId',
            component: ShizenStatsOverview,
            name: 'shizenStatsTeam',
            meta: {
              fallbackRoute: 'shizenStatsCompany',
            },
            children: [
              {
                path: ':userId',
                component: ShizenStatsOverview,
                name: 'shizenStatsUser',
                meta: {
                  fallbackRoute: 'shizenStatsTeam',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  // -----
  // Redirect
  // --
  {
    path: '*',
    component: Dashboard,
  },
];
